module.exports = __webpack_public_path__ + "img/show-tablist.cb106a6f.svg";